<template>
  <section class="flex flex-col flex-auto pb-10">
    <div class="wizard-body w-screen-lg p-4 flex-1 overflow-y-scroll bg-white">
      <transition-group name="fade">
        <WizardStep
          v-for="question in displayQuestions"
          :key="question.step"
          :question="question"
          @items="setStepSelectedItems"
          v-show="showStep(question.step)"
        />
      </transition-group>
      <div
        v-if="isLastStep && lastStepHasSelectedItems"
        class="wizard-cta w-full flex px-4 justify-end pb-8"
      >
        <router-link
          v-if="programs.length"
          :to="{
            name: 'result',
            params: {
              site: questionsConfig.name
            }
          }"
          class="bg-primary text-white font-semibold py-2 px-4 border border-primary disabled:opacity-50 rounded focus:outline-none"
          :disabled="!complete"
        >
          Förderprogramme anzeigen ({{ programs.length }}) →
        </router-link>
        <div
          v-else
          class="bg-primary text-white font-semibold py-2 px-4 border border-primary disabled:opacity-50 rounded focus:outline-none"
        >
          Kein Programm für diese Auswahl verfügbar
        </div>
      </div>
    </div>
    <div class="chat-footer flex px-6 justify-end"></div>
  </section>
</template>

<script>
import { call, get, sync } from 'vuex-pathify'
import WizardStep from '@/components/Wizard/Step'

export default {
  name: 'Wizard',
  components: { WizardStep },
  data() {
    return {
      show: false,
      lastStepHasSelectedItems: false
    }
  },
  computed: {
    questionsConfig: get('questions/config'),
    questions: get('questions/questions'),
    activeStep: sync('questions/activeStep'),
    selection: get('programs/selection'),
    isLastStep: get('questions/isLastStep'),
    programs: get('programs/filtered'),
    complete: get('programs/complete'),
    displayQuestions() {
      return this.questions.filter((q) => {
        if (q.condition) {
          if (!this.selection[q.condition.stepKey]) return false
          return this.selection[q.condition.stepKey].includes(
            q.condition.required
          )
        }
        return true
      })
    },
    availableQuestions() {
      return this.displayQuestions.map((q) => q.step)
    }
  },
  watch: {
    activeStep: function (value) {
      if (!this.availableQuestions.includes(value)) {
        this.nextStep()
      }
    }
  },
  updated() {
    this.scrollToElement('chat-footer')
  },
  methods: {
    nextStep: call('questions/nextStep'),
    showStep(step) {
      if (!this.questionsConfig.steps.includes(step)) return false
      return step <= this.activeStep
    },
    setStepSelectedItems(count) {
      this.lastStepHasSelectedItems = count > 0
    },
    scrollToElement(element) {
      const el = this.$el.getElementsByClassName(element)[0]

      if (el) {
        el.scrollIntoView({ block: 'end', behavior: 'smooth' })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
